export default __webpack_public_path__ + "2c25bd09d5ee08ae5a67c82d4b864596.png";